// tslint:disable
export var CaseCaseFollowUpScenario;
(function (CaseCaseFollowUpScenario) {
    // Nothing/error route
    CaseCaseFollowUpScenario[CaseCaseFollowUpScenario["Undetermined"] = 0] = "Undetermined";
    // Create Workflow
    CaseCaseFollowUpScenario[CaseCaseFollowUpScenario["CreateCase"] = 1] = "CreateCase";
})(CaseCaseFollowUpScenario || (CaseCaseFollowUpScenario = {}));
CaseCaseFollowUpScenario['UNDETERMINED'] = 0;
CaseCaseFollowUpScenario['CREATECASE'] = 1;
//# sourceMappingURL=CaseCaseFollowUpScenario.js.map